export default __webpack_public_path__ + "static/media/EB9DB08D-642C-4607-AB39-680AE1FF7E74_1_105_c.5b9de9ee.jpeg";